<template>
    <div class="cd-section" id="features" >
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/20161108_113035_1.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">SIMPLICITY + POWER</h1>
                        <h3>Controlling Commercial &amp; Industrial Facilities for Over 30 Years</h3>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********     FEATURES 4      *********      -->
        <div class="features-4">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title"> Refrigeration, HVAC &amp; Lighting Control Upgrades, Installation and Support</h2>
                        <!-- <h4 class="description">We are a full service facility control engineering firm, designing, installing and supporting refrigeration, HVAC and lighting control solutions. We provide facility control assessments to help make sense of what you already have or will work with your team to design a new system. <a href="#" v-scroll-to="'#contact'" class="">Contact us</a></h4> -->
                        <h4 class="description">We believe that through the power of intelligent control systems we can help businesses manage their facilities systems better. For the last 30 years, we’ve worked with companies around the globe to drive energy efficiency throughout their refrigeration, HVAC and lighting control systems. <a href="#contact" @click="gConversion()">Contact us</a></h4>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <card type="background" raised color="transparent" style="background-image: url('img/20180829_111935.jpg')">
                            <template slot="info">
                                <div class="icon icon-white">
                                    <i class="now-ui-icons business_badge"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Installation Crew</h4>
                                    <p>We perform high end control system installs.</p>
                                </div>
                            </template>
                        </card>
                    </div>
                    <div class="col-md-4">
                        <card type="background" raised color="transparent" style="background-image: url('img/20161101_172939.jpg')">
                            <template slot="info">
                                <div class="icon icon-white">
                                    <i class="now-ui-icons ui-2_settings-90"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Modernization</h4>
                                    <p>Upgrading Control systems from Legacy Systems.</p>
                                </div>
                            </template>
                        </card>
                    </div>
                    <div class="col-md-4">
                        <card type="background" raised color="transparenr" style="background-image: url('img/46.jpg')">
                            <template slot="info">
                                <!-- <div class="icon icon-white">
                                    <i class="now-ui-icons gestures_tap-01"></i>
                                </div> -->
                                <img v-lazy="'img/GLOGO512.png'" alt="GAMS+ Refrigeration Monitoring" class="" style="width: 48px;filter: drop-shadow(0px 0px 4px #000);">
                                <div class="description">
                                    <h4 class="info-title">Remote Monitoring</h4>
                                    <p>Check out our refrigeration monitoring platform - <router-link class="" to="/facility-refrigeration-monitoring" style="font-weight:bold;font-family: 'Open Sans',sans-serif;"><em>GAMS+</em>&trade;</router-link></p>
                                </div>
                            </template>
                        </card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <div class="section-space" style="height:20px"></div>
                        <h4 class="description">All too often, firms have the "set it and forget it" mentality when it comes to their facility’s control systems. We come along side our clients and help them figure out what they have and how their existing equipment can be enhanced to reduce maintenance costs and increase product safety. <a href="#contact" @click="gConversion()">Contact us</a></h4>
                        <!-- <div class="section-space"></div> -->
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 4      *********      -->
        <!--     *********     FEATURES 8      *********      -->
        <div class="features-8 section-image" style="background-image: url('img/20150625_112325.jpg')">
            <div class="col-md-8 ml-auto mr-auto text-center">
                <h2 class="title">Refrigeration &amp; HVAC Control Systems we Install</h2>
                <!-- <h4 class="description">Woodpecker.co is a follow-up automation SaaS founded in 2015. We’re an international team of 17, speaking 4 languages. Our mission is to enable all B2B companies to connect with their Ideal Customers.</h4> -->
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <card>
                            <div style="width:100%;text-align:center;">
                                <img slot="image" src="img/emersone3.png" class="rounded" alt="">
                            </div>
                            <div class="info text-center" style="padding-top:0px;">
                                <!-- <div class="icon">
                                    <i class="now-ui-icons ui-1_email-85"></i>
                                </div> -->
                                <h4 class="info-title"><a href="https://climate.emerson.com/en-us/">Emerson / CPC</a></h4>
                                <ul style="text-align:left;">
                                    <li>E2 &amp; E2e</li>
                                    <li>Lumity Site Supervisor</li>
                                    <li>Lumity E3</li>
                                </ul>
                            </div>
                        </card>
                    </div>
                    <div class="col-md-3">
                        <card>
                            <div style="width:100%;text-align:center;">
                                <img slot="image" src="img/danfoss800a.png" class="rounded" alt="">
                            </div>
                            <div class="info text-center" style="padding-top:0px;">
                                <!-- <div class="icon">
                                    <i class="now-ui-icons ui-1_calendar-60"></i>
                                </div> -->
                                <h4 class="info-title"><a href="https://www.danfoss.com/en-us/">Danfoss</a></h4>
                                <!--  -->
                                <ul style="text-align:left;">
                                    <li>AK-SM 800A series</li>
                                    <li>AK-SM 800 series</li>
                                    <li>AK-SC 255</li>
                                </ul>
                            </div>
                        </card>
                    </div>
                    <div class="col-md-3">
                        <card>
                            <div style="width:100%;text-align:center;">
                                <img slot="image" src="img/dmtouch.png" class="rounded" alt="">
                            </div>
                            <div class="info text-center" style="padding-top:0px;">
                                <!-- <div class="icon">
                                    <i class="now-ui-icons ui-1_send"></i>
                                </div> -->
                                <h4 class="info-title"><a href="https://www.resourcedm.com/">Resource Data Management</a></h4>
                                <ul style="text-align:left;">
                                    <li>DM Touch</li>
                                    <li>TBD The Data Builder</li>
                                    <li>Intuitive V2</li>
                                </ul>
                            </div>
                        </card>
                    </div>
                    <div class="col-md-3">
                        <card>
                            <div style="width:100%;text-align:center;">
                                <img slot="image" src="img/parkermicrothermo.png" class="rounded" alt="">
                            </div>
                            <div class="info text-center" style="padding-top:0px;">
                                <!-- <div class="icon">
                                    <i class="now-ui-icons ui-2_like"></i>
                                </div> -->
                                <h4 class="info-title">Other Systems</h4>
                                <ul style="text-align:left;">
                                    <li><a href="https://sporlanonline.com/micro-thermo/">Parker Micro&nbsp;Thermo</a></li>
                                    <li><a href="https://mcscontrols.com/">Micro Control Systems</a></li>
                                    <li><a href="https://www.carel.com/web/guest">Carel</a></li>
                                    <li><a href="https://www.bitzer.de/us/us/">Bitzer</a></li>
                                    <li><a href="https://www.johnsoncontrols.com/industrial-refrigeration/frick-refrigeration">Frick</a></li>
                                    <li><a href="https://climate.emerson.com/en-us/brands/vilter">Vilter</a></li>
                                    <li><a href="https://www.mayekawa.com/mycom/index.html">MYCOM</a></li>
                                </ul>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 8      *********      -->
        <!--     *********    PROJECTS 5     *********      -->
        <div class="projects-5 controls-card" style="padding-top:0px;">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">List of Legacy Refrigeration Control Systems we Upgrade</h2>
                        <!-- <h4 class="description">This is the paragraph where you can write more details about your -->
                            <!-- projects. Keep you user engaged by providing meaningful information.</h4> -->
                        <div class="section-space"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 ml-auto">
                        <card type="background" raised class="card-background-product commercial" v-lazy:background-image="'img/20180822_102458.jpg'">
                            <h2 class="card-title">Commercial</h2>
                            <p class="card-description">
                                Supermarkets, Small Store Formats
                            </p>
                            <!-- <badge type="neutral">Analytics</badge> -->
                            <!-- <span class="n-badge badge-neutral">Analytics</span> -->
                        </card>
                    </div>
                    <div class="col-md-5 mr-auto">
                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Danfoss NC25 - AKCESS25"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Danfoss AKcess55"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Danfoss AK-SC255"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Com-trol 4k"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="EIL/ECI RC2000 &amp; EC1000"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="CPC RMCC"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="CPC IPC"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="CPC Einstein"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Mechanical Time Clocks &amp; Pressure Switche"
                                      description=""
                        />

                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-md-5 visible-sm">
                        <!-- <card type="background" raised class="card-background-product" v-lazy:background-image="'img/20170710_153002.jpg'"> -->
                        <card type="background" raised class="card-background-product" v-lazy:background-image="'img/industrial.png'">
                            <h2 class="card-title">Industrial</h2>
                            <p class="card-description ">
                                Warehouses, Pharmaceuticals, Testing Facilities
                            </p>
                            <!-- <badge type="neutral">Trello</badge> -->
                            <!-- <span class="n-badge badge-neutral">Trello</span> -->
                        </card>
                    </div>
                    <div class="col-md-5 ml-auto last-p5card">
                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Danfoss NC25 - Dunham Bush"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Heatcraft - Beacon2"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Frick - Quantum LX &amp; Quantum 4A"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Vilter - Vission &amp; Vantage"
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Logic Controls - Ecube "
                                      description=""
                        />

                        <info-section type="success"
                                      icon="now-ui-icons ui-2_like"
                                      title="Mechanical Time Clocks &amp; Pressure Switche"
                                      description=""
                        />
                    </div>
                    <div class="col-md-5 mr-auto hidden-sm">
                        <card type="background" raised class="card-background-product" v-lazy:background-image="'img/industrial.png'">
                            <h2 class="card-title">Industrial</h2>
                            <p class="card-description ">
                                Warehouses, Pharmaceuticals, Testing Facilities
                            </p>
                            <!-- <badge type="neutral">Trello</badge> -->
                            <!-- <span class="n-badge badge-neutral">Trello</span> -->
                        </card>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END PROJECTS 5      *********      -->
        <div class="about-contact">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 mr-auto ml-auto text-center">
                        <h2 class="text-center title">Legacy Danfoss Parts</h2>
                        <h4 class="text-center description">We have maintained an extensive inventory of all legacy Danfoss parts which are available for immediate delivery. Danfoss purchased EIL/ECI in the mid-1990s and discontinued manufacturing all EIL / ECI parts. ETC is pleased to provide an extensive inventory of all EIL /ECI parts.</h4>
                            <router-link to="/legacyparts" class="btn btn-primary btn-lg">Legacy Parts</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="latest != null && latest.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Related Articles</h2>
                        <br />
                        <template  v-for="article in latest">
                        <card type="blog" plain :key="article._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="article.headerimg" @click="goTo(article._id)"  style="cursor:pointer;"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                    </h3>
                                    <p class="card-description">
                                        {{article.readmore}}
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                    </p>
                                    <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div>
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Refrigeration Controls',
      meta: [
        { vmid: 'description', name: 'description', content: 'Commercial & Inustrial Refrigeration Control Upgrades, Installation and Support. Refrigeration, HVAC & Lighting Controls.' },
        { vmid: 'keywords', name: 'keywords', content: 'modern control systems, refrigeration, controls, commercial controls, industrial controls, danfoss, emerson, HVAC, HVAC controls, refrigeration controls,danfoss NC25,danfoss Akcess25,danfoss Akcess55, cpc RMCC, EIL RC200, EIL EC1000, Com-trol 4k, Dunam Bush, Heatcraft, Beacon2, Frick Quantum LX, frick Quantum 4A, cpc ipc, cpc einstein, velter vission, vilter vantage, logic controls ecube' }
      ],
      links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com/facility-refrigeration-controls'}
            ]
    },
    data () {
        return {
            latest: null,
            domain: 'https://api.website.gamsplus.systems',
        }
    },
    mounted() {
        this.getLatest()
    },
    methods: {
        // track () {
        //     // setTimeout(() => {
        //         this.$ga.page(this.$router)
        //     // }, 1000);
        // },
        getLatest() {
            this.$http.post(this.domain+'/articles/similar/Controls',{
                    'title': '',
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
                
            })
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
            // window.scrollTo(0,0);
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    },
  }
</script>

<style scoped>

@media (min-width: 769px){
.visible-sm{
        display:none;
    }
}
@media (max-width: 768px){
.last-p5card{
        margin-bottom: 50px;
        margin-top: 3rem;
    }
    .hidden-sm{
        display:none;
    }
}
@media (max-width: 768px){
    h1.title{
        font-size:5em;
    }
    .projects-5 .card-background {
        margin-bottom: 30px;
    }
    .projects-5 hr {
        margin-bottom: 0px;
    }
}
@media screen and (min-width: 991px){
    h1.title{
        font-size:7em;
    }
}
@media screen and (max-width: 576px){
    h1.title{
        font-size:3.5em;
    }
    
}

</style>